export const companyStudentDeviceModel = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
